import { required, optional, array, obj } from 'AppReact/schema';

export const additionalOrder = {
  category: optional('string'),
  created_by: optional('string'),
  entry_allowed: optional('boolean'),
  has_pet: optional('boolean'),
  level: optional('string'),
  id: optional('integer'),
  last_event: obj({
    created_by: optional('string'),
    datetime: optional('jsDate'),
    description: optional('string'),
    event_name: optional('string'),
    id: optional('integer'),
  }),
  property: obj({
    id: optional('integer'),
    name: optional('string'),
  }),
  property_id: optional('integer'),
  status: optional('string'),
  subcategory: optional('string'),
  submitted: optional('string'),
  tenant: optional('string'),
  ticket: optional('string'),
  unit: optional('string'),
  tech_name: optional('string'),
  completed_at: optional('jsDate'),
  inserted_at: optional('jsDate'),
}